import { Grid } from "@mui/material"
import { Constants } from "../../../utils"
import Logo from "../../../assets/img/logo animation.svg"
import { Outlet } from "react-router-dom"

export const LayoutLP = ({
    background = "transparent",
    useBullets = true
}: {
    background?: string,
    useBullets?: boolean
}) => {
    return (
        <Grid
            sx={{
                width: "100vw",
                height: "100%",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                backgroundColor: background,
                ... (useBullets && {
                    backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="22" height="22"%3E%3Ccircle cx="1.5" cy="1.5" r="1.5" fill="rgba(0, 0, 0, .06)" /%3E%3C/svg%3E')`,
                    backgroundSize: "10x 10px",
                })
            }}
        >
            <Grid
                padding={"4rem 2rem"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"flex-start"}
                width={"100vw"}
                height={"100%"}
                maxWidth={`${Constants.screenMaxWidth}px`}
                gap={"1rem"}
            >
                <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    flexWrap={"nowrap"}
                    justifyContent={"space-between"}
                >
                    <img
                        src={Logo}
                        alt="logo"
                        style={{
                            width: "7.1rem",
                            height: "3.3rem"
                        }} />
                </Grid>
                <Outlet />
            </Grid>
        </Grid>
    )
}